/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { ReactNode, useEffect, useState, PropsWithChildren } from "react";

export const NoSSR = ({ children }: PropsWithChildren): ReactNode => {
	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	return isClient ? children : <></>;
};
